import { useCallback } from 'react';
import type { IScreensLogging } from 'shared/src/api/types';
import { bridge } from 'shared/src/utils';
import { useAtomicScreen } from '../../AtomicRenderer/context/AtomicScreenContext';

type LogClickMeatballsParams = {
  logging?: IScreensLogging;
};

export const useLogClickMeatballs = () => {
  const screen = useAtomicScreen();

  return useCallback(
    ({ logging }: LogClickMeatballsParams) => {
      bridge.logAnalyticsEvent({
        name: 'CLICK_MEATBALLS',
        analytics: {
          ...logging?.analytics,
          ...(screen != null && screen !== '' && { SCREEN: screen }),
          TYPE: 'BUTTON',
        },
        ably_only_log: logging?.ably_only_log,
      });
    },
    [screen],
  );
};
